<template>
    <div style="height: 100%">
        <template v-if="isAdviser()">
            <adviser-dashboard />
        </template>
        <template v-else>
            <investor-dashboard />
        </template>
    </div>
</template>

<script>
export default {
    name: 'Dashboard',
    components: {
        AdviserDashboard: () =>
            import(
                /* webpackChunkName: "core" */
                '@/views/AdviserDashboard'
            ),
        InvestorDashboard: () =>
            import(
                /* webpackChunkName: "core" */
                '@/views/InvestorDashboard'
            )
    },
    beforeDestroy() {
        this.showBreadcrumbs();
    },
    mounted() {
        this.hideBreadcrumbs();
    }
};
</script>
